var map = {
	"./1.svg": "1d3b",
	"./10.svg": "16f4",
	"./11.svg": "397d",
	"./12.svg": "162f",
	"./13.svg": "a915",
	"./2.svg": "a100",
	"./3.svg": "535a",
	"./4.svg": "8401",
	"./5.svg": "7fd9",
	"./6.svg": "f6e7",
	"./7.svg": "720e",
	"./8.svg": "5363",
	"./9.svg": "fbf8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2cbd";